'use strict';

import angular from 'angular';
import grid from 'angular-ui-grid';
import mouse from '../../components/mouse/mouse';
import documentMovements from '../document-movements/document-movements.component';


export class JournalComponent {

  closeWindow: Function;
  addWindow: Function;
  isAllowedForEdit: Function;
  editDocument: Function;

  me;
  data;
  options;
  selected;
  grid;
  contextMenu;
  documents;
  rows = [];

  /*@ngInject*/
  constructor($scope, Storage, WindowService, Auth) {
    this.Storage = Storage;
    this.scope   = $scope;

    this.closeWindow = WindowService.delItem;
    this.addWindow   = WindowService.addItem;

    this.scope.isAllowedForEdit = this.isAllowedForEdit.bind(this);
    this.scope.editDocument     = this.editDocument.bind(this);

    this.contextMenu = {
      show: false,
      left: 0,
      top: 0
    };

    Auth.getCurrentUser()
      .then(user => {
        this.me = user;
      });
  }

  $onInit() {

    this.scope.onRightClick = (event) => {
      var element = angular.element(event.toElement);

      //get cellId which for the thrid row should something like this
      //1464688691229-2-uiGrid-0006-cell
      var id = element[0].parentElement.id;

      if( ! id){
        return;
      }

      var result = id.match(/(\d+)/g);
      var rowIndex = parseInt(result[1]); //extract second numeric match

      this.grid.selection.selectRowByVisibleIndex(rowIndex); 

      this.contextMenu.show = true;
      this.contextMenu.left = event.pageX - this.data.x;// - event.offsetX;
      this.contextMenu.top  = event.pageY - this.data.y - event.offsetY;
    };

    return this.Storage.loadDocuments()
      .$promise
      .then((documents) => {
        this.documents = documents;
        this.refresh();

        this.options = {
          primaryKey: '_id',
          enableCellEdit: true,
          enableRowSelection: true,
          enableRowHeaderSelection: false,
          multiSelect: false,
          modifierKeysToMultiSelect: false,
          noUnselect: true,
          rowEditWaitInterval: -1,
          data: this.rows,
          rowTemplate: require('./journal.tableRow.html'),
          onRegisterApi: (gridApi) => {
            this.grid = gridApi;

            this.grid.selection.on.rowSelectionChanged(this.scope, (row) => {
              this.selected = undefined;

              if(row.isSelected){
                this.selected = row.entity;
              }
            });

            this.grid.edit.on.afterCellEdit(this.scope, (rowEntity, colDef, newValue, oldValue) => {
              
              if(oldValue  == newValue) {
                return false;
              }

              if(rowEntity.openedBy && rowEntity.openedBy != this.me._id){
                return this.error("Документ редактируется другим пользователем!");
              }

              return this.Storage.saveDocument(rowEntity)
                .then(() => this.grid.rowEdit.setRowsClean([rowEntity]))
                .catch(err => this.error(err.message || "Ошибка при сохранении"));
            });
          },
          columnDefs: [{
            displayName: '#',
            field: '_id',
            groupable: false,
            resizable: false,
            sortable: false,
            visible: false,
            width: 50
          }, {
            displayName: 'Тип',
            field: 'type',
            sortable: false,
            resizable: false,
            width: 50,
            //cellFilter: 'renderType',
            cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderType"></div>',
            cellEditableCondition: () => false
          }, {
            displayName: 'Статус',
            field: 'status',
            sortable: false,
            resizable: false,
            width: 50,
            //cellFilter: 'renderStatus',
            cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderStatus"></div>',
            cellEditableCondition: () => false
          }, {
            displayName: 'Редактировать',
            field: 'status',
            sortable: false,
            resizable: false,
            width: 50,
            type: 'boolean',
            cellTemplate: '<div class="ui-grid-cell-contents"><div ng-if="grid.appScope.isAllowedForEdit(row.entity)">' + 
              '<button type="button" class="btn btn-sm btn-success" title="Редактирова докумен" ng-click="grid.appScope.editDocument(row.entity)">' + 
              '<span class="glyphicon" ng-class="{\'glyphicon-pencil\': !row.entity.openedBy, \'glyphicon-floppy-disk\': row.entity.openedBy}" aria-hidden="true"></span>' + 
              '</button>' +
              '</div></div>',
            //cellEditableCondition: () => false
          }, {
            displayName: '№',
            field: 'number',
            groupable: false,
            resizable: true,
            sortable: true,
            visible: true,
            width: 100,
            cellEditableCondition: () => false
          }, {
            displayName: 'Дата/Время',
            field: 'dtime',
            groupable: false,
            resizable: true,
            sortable: true,
            visible: true,
            width: 150,
            cellFilter: "date:'dd.MM.yy HH:mm'",
            sort: {
              direction: 'desc',
              priority: 100 
            },
            cellEditableCondition: () => false
          }, {
            displayName: 'Сумма',
            field: 'amount',
            width: 100,
            cellFilter: 'currency',
            cellEditableCondition: () => false
          }, {
            displayName: 'Комментарий',
            field: 'comment',
            groupable: false,
            resizable: false,
            sortable: false,
            visible: true,
          }]
        };
      });
  }

  editDocument(doc) {
    if(doc.openedBy){
      doc.openedBy = null;
    } else {
      doc.openedBy = this.me._id;
    }

    return this.Storage.saveDocument(doc)
      .then(() => this.grid.rowEdit.setRowsClean([doc]))
      .catch(err => this.error(err.message || "Ошибка при сохранении"));
  }

  isAllowedForEdit(doc) {

    if( ! this.me){
      return false;
    }

    if(doc.status != 0){
      return false;
    }

    if( ! doc.openedBy){
      return true;
    }

    return doc.openedBy == this.me._id;
  }

  refresh() {
    while(this.rows.length > 0){
      this.rows.shift();
    }

    this.documents.forEach((doc) => {
      if(doc.status < 2){
        this.rows.push(doc);
      }
    });
  }

  openMovements() {
    if(this.selected.openedBy && this.selected.openedBy != this.me._id){
      return this.error("Документ редактируется другим пользователем!");
    }

    this.addWindow({
      id: 'document-movements-window',
      component: 'document-movements',
      document: this.selected,
      title: 'Движения ' + this.selected.number + (this.selected.comment ? ' (' + this.selected.comment + ')' : ''),
      width: 800,
      height: 500
    });
  }

  changeStatus(status) {

    if(this.selected.openedBy && this.selected.openedBy != this.me._id){
      return this.error("Документ редактируется другим пользователем!");
    }

    this.selected.status = status;

    return this.Storage.saveDocument(this.selected)
      .then(() => {
        this.refresh();
      })
      .catch(err => {
        console.error(err);
      });
  }

  close() {
    this.closeWindow(this.data.id);
  }
}

export default angular.module('storageApp.journal', [
    grid,
    grid + '.selection',
    grid + '.edit',
    grid + '.rowEdit',
    grid + '.saveState',
    grid + '.grouping',

    mouse,
    documentMovements
  ])
  .filter('renderStatus', ($sce) => {
    'ngInject';

    return (input) => {
      return $sce.trustAsHtml((() => {
        var icon = 'question-sign';
        var title = 'Не известный статус документа';
        switch(input){
          case 0: title = 'Черновик';   icon = 'edit';          break;
          case 1: title = 'Проведен';   icon = 'ok-circle';     break;
          case 2: title = 'Отменен';    icon = 'remove-circle'; break;
        }

        return '<span class="glyphicon glyphicon-' + icon + '" aria-hidden="true" title="' + title + '"></span>';
      })());
    };
  })
  .filter('renderType', ($sce) => {
    'ngInject';

    return (input) => {
      return $sce.trustAsHtml('<span class="glyphicon glyphicon-' + (input == 'expenditure' ? 'minus' : 'plus') + ' document-' + input + '" title="' + (input == 'expenditure' ? 'Расход' : 'Приход') + '" aria-hidden="true"></span>');
    };
  })
  .component('journal', {
    bindings: {data: '='},
    transclude: true,
    template: require('./journal.html'),
    controller: JournalComponent,
    controllerAs: 'journalCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/journal/journal.component.js